"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addSumToDisplayValue = void 0;
const formatAmountWithPoints_1 = require("../formatters/formatAmountWithPoints");
/**
 * addSumToDisplayValue function for adding values
 *
 * @param displayValue
 * @returns string
 */
const addSumToDisplayValue = (displayValue, toAdd) => {
    let convertedToAdd = parseFloat(toAdd.toFixed(displayValue.exponent));
    convertedToAdd *= Math.pow(10, displayValue.exponent);
    displayValue.valueInMinUnit += convertedToAdd;
    displayValue.displayValue =
        displayValue.displayUnit === "dollars"
            ? (displayValue.valueInMinUnit / Math.pow(10, displayValue.exponent)).toFixed(2)
            : (0, formatAmountWithPoints_1.inputToPts)((displayValue.valueInMinUnit / Math.pow(10, displayValue.exponent)).toFixed());
    return displayValue;
};
exports.addSumToDisplayValue = addSumToDisplayValue;
